import { render } from "./AuthFromForge.vue?vue&type=template&id=37305bc0&scoped=true"
import script from "./AuthFromForge.vue?vue&type=script&lang=js"
export * from "./AuthFromForge.vue?vue&type=script&lang=js"

import "./AuthFromForge.vue?vue&type=style&index=0&id=37305bc0&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37305bc0"]])

export default __exports__